import React from "react";
import ReactDOM from "react-dom";
import Root from "./Root";
import initDi from "./core/di/init";

initDi();

ReactDOM.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
  document.getElementById("root")
);
